import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Button, Spinner } from "react-bootstrap";
import { getTariffById, updateTariff } from "../services/tariffService";
import { getRouterById } from "../services/routerService";
import FormComponent from "./common/formComponent";
import { Paper } from "@material-ui/core";
import PageLoading from "./common/pageLoading";

class TariffInfo extends FormComponent {
  state = {
    data: {
      _id: "",
      title: "",
      type: "",
      category: "",
      price: "",
      validity: "",
      isPublished: "false",
      isDecommisioned: "",
      pppProfile: "",
      nRouterId: "",
    },
    loading: true,
    processing: false,
    errors: {},
    router: {},
  };

  schema = {
    _id: Joi.string().required().label("Id"),
    title: Joi.string().required().label("Title"),
    type: Joi.string().required().label("Type"),
    category: Joi.string().required().label("Category"),
    price: Joi.number().min(0).required().label("Price"),
    validity: Joi.number().min(1).required().label("Validity"),
    isPublished: Joi.boolean().required().label("Published"),
    isDecommisioned: Joi.boolean().required().label("Decommisioned"),
    pppProfile: Joi.string().required().label("PPP Profile"),
    nRouterId: Joi.string().required().label("Router"),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload } = this.state;

    try {
      await updateTariff(payload);

      this.props.history.push("/tariffs");
      toast.success("Tariff Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async componentDidMount() {
    const { data } = await getTariffById(this.props.match.params.id);
    const { data: router } = await getRouterById(data.nRouterId);
    this.setState({ data, router, loading: false });
  }

  render() {
    const { data, errors, router, loading, processing } = this.state;
    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <div className="row">
              <div className="col-md">
                <h5>{data.title}</h5>
              </div>
              <div className="col-md"></div>
            </div>
          </div>
          <div className="card-body">
            {loading && <PageLoading loading={loading} />}
            {!loading && (
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="title">
                  <Form.Label>Title</Form.Label>
                  <Form.Control
                    name="title"
                    onChange={this.handleChange}
                    value={data.title}
                    size="sm"
                    type="text"
                    autoFocus
                  />
                  {errors.title && <span className="text-danger">{errors.title}</span>}
                </Form.Group>

                <Form.Group controlId="type">
                  <Form.Label>Type</Form.Label>
                  <Form.Control readOnly defaultValue={data.type} />
                </Form.Group>

                <Form.Group controlId="category">
                  <Form.Label>Category</Form.Label>
                  <Form.Control readOnly defaultValue={data.category} />
                </Form.Group>

                <Form.Group controlId="price">
                  <Form.Label>Price</Form.Label>
                  <Form.Control name="price" onChange={this.handleChange} value={data.price} size="sm" type="text" />
                  {errors.price && <span className="text-danger">{errors.price}</span>}
                </Form.Group>

                <Form.Group controlId="vat">
                  <Form.Label>PPP Profile</Form.Label>
                  <Form.Control
                    name="pppProfile"
                    onChange={this.handleChange}
                    value={data.pppProfile}
                    size="sm"
                    type="text"
                  />
                  {errors.pppProfile && <span className="text-danger">{errors.pppProfile}</span>}
                </Form.Group>

                <Form.Group controlId="validity">
                  <Form.Label>
                    Validity <small>(Days)</small>
                  </Form.Label>
                  <Form.Control
                    name="validity"
                    onChange={this.handleChange}
                    value={data.validity}
                    size="sm"
                    type="text"
                  />
                  {errors.validity && <span className="text-danger">{errors.validity}</span>}
                </Form.Group>

                <Form.Group controlId="router">
                  <Form.Label>Router</Form.Label>
                  <Form.Control readOnly defaultValue={router.name} />
                </Form.Group>
                <Button disabled={this.validate() || processing} type="submit" variant="primary">
                  {processing && (
                    <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                  )}
                  Update
                </Button>
              </Form>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

export default TariffInfo;
